import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Projectideafsk() {
  return (
    <div className="projectidea_fsk p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
            <div className="idea-fsk-content">
              <h2>
                Project <span>Idea</span>
              </h2>
              <h6>Goals set for TekRevol</h6>
              <p>
                Theforemost goal for TekRevol was to create an immersive gaming
                experience in"FSK." This involved seamlessly integrating
                captivating match-3puzzles and time management challenges into a
                cohesive and engaging gameplaystructure.
              </p>
              <p>
                TekRevolaimed to craft a compelling role-playing narrative
                within "FSK." Thegoal was to go beyond traditional gaming
                experiences, providing players with astoryline that enhances
                their connection to the game and the virtual restaurantempire
                they are building.
              </p>
              <p>
                Anotherkey goal was to empower players by infusing real-time
                market strategies intotheir gaming strategy. TekRevol aspired to
                create a dynamic and strategicgaming environment where players
                could apply real-world market concepts tosucceed in building and
                managing their restaurant empires.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="">
            <div className="idea-fsk-img">
              <StaticImage
                src="../../../images/case-studies/fsk/project-idea.webp"
                alt="TekRevol"
                className="logo_img"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={886}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Projectideafsk;
